import { render, staticRenderFns } from "./ChooseLocation.vue?vue&type=template&id=1b50b2f2&scoped=true&"
import script from "./ChooseLocation.vue?vue&type=script&lang=js&"
export * from "./ChooseLocation.vue?vue&type=script&lang=js&"
import style0 from "./ChooseLocation.vue?vue&type=style&index=0&id=1b50b2f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b50b2f2",
  null
  
)

export default component.exports